import React, { useMemo } from 'react'
import { Row, Col, Button } from 'antd';
import HelixImg from '../assets/newlayout/welcome_text_img.svg';
import RightImgOne from '../assets/newlayout/right_img_one.svg';

const connectorPaths = [
    'M214 0.30006L214 269.3',
    'M332.012 1140.3L332.012 871.3',
    'M94 449.3L94 365.3',
    'M214 449.3L214 365.3',
    'M334 449.3L334 365.3',
    'M93 781.3L93 697.3',
    'M213 781.3L213 697.3',
    'M333 781.3L333 697.3',
    'M467 651.971L387 651.971',
    'M467 570.971L387 570.971',
    'M467.004 490.471L387.001 489.471',
];

const WelcomeToHelix = () => {
    const animatedConnectors = useMemo(() => (
        connectorPaths.map((path) => ({
            path,
            duration: `${(1 + Math.random() * 0.9).toFixed(2)}s`,
            delay: `${(Math.random() * 1.8).toFixed(2)}s`,
        }))
    ), []);

    return (
        <div className='welcome_to_helix_div'>
            <Row>
                <Col span={9} className='welcome_to_helix_content'>
                    <div className='welcome_to_helix_heading'>
                        <div className='welcome_to_helix_text'>
                            <img src={HelixImg} className='img-fluid' alt="Helix" />
                            <p>To kick things off, we'd love to learn more about your company to better serve your needs.</p>
                        </div>
                        <div className='btn_group'>
                            <Button className='btn btn_primary w_fit_content md'>Let’s get Started!</Button>
                        </div>
                    </div>
                </Col>
                <Col span={15} className='welcome_to_helix_content position-relative'>
                    <div className='welcome_to_helix_img'>
                        <img src={RightImgOne} className='img-fluid' alt="Right Image One" />
                        <svg
                            className="welcome_to_helix_connector_animation"
                            viewBox="0 0 910 1141"
                            aria-hidden="true"
                        >
                            {animatedConnectors.map(({ path, duration, delay }, index) => (
                                <path
                                    key={`${path}-${index}`}
                                    d={path}
                                    pathLength="100"
                                    className="welcome_to_helix_connector_animation__line"
                                    style={{ '--line-duration': duration, '--line-delay': delay }}
                                />
                            ))}
                        </svg>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default WelcomeToHelix
